// extracted by mini-css-extract-plugin
var _1 = "TopicPostSection-module__animatedBackground--rIq1d";
var _2 = "TopicPostSection-module__loadMoreContainer--Kyvkr";
var _3 = "TopicPostSection-module__posts--luPxg";
var _4 = "TopicPostSection-module__titleLink--E3ql8";
export { _1 as "animatedBackground", _2 as "loadMoreContainer", _3 as "posts", _4 as "titleLink" }
